import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {Divider, Drawer, Typography} from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import ImageIcon from '@material-ui/icons/Image';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import SettingsIcon from '@material-ui/icons/Settings';
import {Work, School, BuildRounded, WorkOutlineRounded, ListAltRounded, FilterNoneRounded, SearchRounded} from '@material-ui/icons';
import { AwesomeButton } from 'react-awesome-button';
import 'react-awesome-button/dist/styles.css';
import { Profile, SidebarNav } from './components';
import Cookies from 'universal-cookie';
import Box from '@material-ui/core/Box';

const cookies = new Cookies();
const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));


let url
if(cookies.get('isAlumni') === "true"){
  url = "https://forms.gle/y2c6EVuwTJ3TTqXA7"
} else {
  url = "https://forms.gle/EivxPzkv1c3JCntc9"
}

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;

  const classes = useStyles();
  let pages;
  if(cookies.get('isAlumni') === "true"){
    pages = [
      {
        title: 'Internship Offers',
        href: '/offers',
        icon: <WorkOutlineRounded/>
      },
      {
        title: 'My Applications',
        href: '/my-applications',
        icon: <ListAltRounded />
      },
      {
        title: 'My Published Offers',
        href: '/my-offers',
        icon: <FilterNoneRounded />
      },
      {
        title: 'Internship Seekers',
        href: '/seekers',
        icon: <SearchRounded />
      },
      {
        title: 'My Profile',
        href: '/account',
        icon: <AccountBoxIcon />
      },
      {
        title: 'Settings',
        href: '/settings',
        icon: <SettingsIcon />
      }
    ];
  }else{
    pages = [
      {
        title: 'Internship Offers',
        href: '/offers',
        icon: <WorkOutlineRounded />
      },

      {
        title: 'Job Offers',
        href: '/soon',
        icon: <Work />,
        iconEnd: <BuildRounded/>
      },
      {
        title: 'Masters Programs',
        href: '/soon',
        icon: <School />,
        iconEnd: <BuildRounded/>
      },
      {
        title: 'My Applications',
        href: '/my-applications',
        icon: <ListAltRounded />
      },
      {
        title: 'My Profile',
        href: '/account',
        icon: <AccountBoxIcon />
      },
      {
        title: 'Settings',
        href: '/settings',
        icon: <SettingsIcon />
      }
    ];
  }
  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
          pages={pages}
        />
        <div
          style={{
            position: 'absolute',left: '10%',
            bottom:30}}
        >
          <AwesomeButton
            href={url}
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              left: '10%',
              width: '100%'}}
            type="primary"
          >
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
              style={{color: 'white', marginTop: 5}}
            >
              <Box fontWeight="fontWeightBold"  fontSize={16} m={1}>
                Leave Feedback
              </Box>
            </Typography>
          </AwesomeButton>
          {/* <AwesomeButton
            href="https://donorbox.org/aui-itternship-manager"
            type="link"
          >

              Support the Developers
          </AwesomeButton> */}
        </div>
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
